<template>
  <div>
    <app-header />
    <side-bar
      @openTrace="showTrace()"
      @openConfig="showQuickConfig()"
    />
    <transition
      mode="out-in"
      name="component-fade"
    >
      <trace
        v-if="showTracePage"
        @closeTrace="hideTrace()"
      />
      <quick-config
        v-if="showConfig"
        @closeConfig="hideQuickConfig()"
      />
      <consumer
        v-if="showConsumer"
        @closeConsumer="hideConsumerPanel()"
      />
    </transition>
    <transition
      mode="out-in"
      name="component-fade"
    >
      <router-view />
    </transition>
    <div v-if="!currentRoutePath.includes('configuration')">
      <app-footer />
    </div>
  </div>
</template>

<script>
import Header from '@/components/shared/header/header.vue'
import SideBar from '@/components/shared/side-bar/side-bar.vue'
import Trace from '@/components/shared/trace/trace.vue'
import QuickConfig from '@/components/shared/quick-configuration/quick-configuration.vue'
import { CONSTANT } from '../../utils/constant.js'
import sharedService from '../../utils/shared-service'
import Footer from '@/components/shared/footer/footer'
import { EventBus } from '../../event-bus'
import utils from '../../utils/utils'
import ConfigurationService from '../configuration/configuration.service'
import orchestration from '../../orchestration'
import Consumer from '@/components/consumer/consumer'

const configurationService = new ConfigurationService()

export default {
  name: 'App',

  components: {
    'side-bar': SideBar,
    'app-header': Header,
    'trace': Trace,
    'quick-config': QuickConfig,
    'app-footer': Footer,
    'consumer': Consumer
  },

  data () {
    return {
      showTracePage: false,
      showConfig: false,
      environment: CONSTANT.CONFIG.ENVIRONMENT.SANDBOX,
      currentRoutePath: '',
      showConsumer: false
    }
  },

  watch: {
    $route () {
      this.currentRoutePath = this.$router.currentRoute.path
    }
  },

  mounted () {
    EventBus.$on('openConsumer', (event) => {
      this.showConsumer = event
    })

    sharedService.setAppInstanceId()
    this.currentRoutePath = this.$router.currentRoute.path
    if (localStorage.getItem('setEnv')) {
      this.environment = localStorage.getItem('setEnv')
    } else {
      localStorage.setItem('setEnv', this.environment)
    }
    configurationService.setConfigDataOnEnvironment(this.environment)
    this.initializeConfiguration()
  },

  methods: {

    async initializeConfiguration () {
      try {
        await this.$store.dispatch('appInit')
        utils.loaderTimeOut(10000)
        await this.$store.dispatch('lightBoxloaderOn', true)
        await this.$store.dispatch('updateEnvironment', this.environment)
        await this.loadAllApi()
        await this.$store.dispatch('lightBoxloaderOn', false)
      } catch (e) {
        await this.$store.dispatch('lightBoxloaderOn', false)
      }
    },

    async loadAllApi () {
      await Promise.all([
        configurationService.getEnvironments().then(response => {
          this.$store.dispatch('updateAllEnvironments', response)
        }),
        sharedService.loadSrcConfiguration(this.environment),
        sharedService.loadSrcKeys(this.environment),
        sharedService.loadApiEndPoint(this.environment).then(() => {
          this.loadAllSdk()
        })
      ]).then(response => {
        EventBus.$emit('refreshSrcId')
      })
    },

    loadAllSdk () {
      orchestration.callMethod({ methodName: CONSTANT.TRACE.METHOD.BOOTSTRAP }).then(() => {
        setTimeout(() => {
          this.$store.dispatch('updateAllSdkLoaded', true).then(() => {
            EventBus.$emit('changeConfiguration')
            EventBus.$emit('refreshSrcId')
          })
        }, 1000)
      })
    },

    showTrace () {
      this.showTracePage = true
    },

    hideTrace () {
      this.showTracePage = false
    },

    showQuickConfig () {
      this.showConfig = true
    },

    hideQuickConfig () {
      this.showConfig = false
    },
    hideConsumerPanel () {
      this.showConsumer = false
      this.$store.commit('setEnableNTSFlow', false)
    }

  }
}
</script>
